import Route from '@ember/routing/route';

export default class MySourcesRoute extends Route {}
